import React from 'react';
import ReactDom from 'react-dom';
import BSAlert from 'react-bootstrap/Alert';

const alertPortal = document.getElementById('cs-alert-portal');


class Alert extends React.Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);

    this.el = document.createElement('div');
  }

  componentDidMount() {
    alertPortal.appendChild(this.el);
  }

  componentWillUnmount() {
    alertPortal.removeChild(this.el);
  }

  onClose() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    var alertContent = (
      <BSAlert variant="danger" dismissible onClose={this.onClose}>
        <BSAlert.Heading>Error:</BSAlert.Heading>
        {this.props.children}
      </BSAlert>
    );

    return ReactDom.createPortal(
      alertContent,
      this.el
    );
  }
}


export default Alert;

